import { supabase } from '@/lib/supabase'
import { FriendlyError } from './auth'

export interface Department {
  id: string
  code: string
  name: string
  is_central: boolean
}

/**
 * Departments the signed-in person is allowed to see. Row-level security decides
 * which: a treasurer gets the department list (names only), an admin the same.
 */
export async function listDepartments(opts: { includeRetired?: boolean } = {}): Promise<Department[]> {
  let q = supabase.from('department').select('id, code, name, is_central, archived_at')
  if (!opts.includeRetired) q = q.is('archived_at', null)
  const { data, error } = await q.order('is_central', { ascending: false }).order('name')
  if (error) throw new FriendlyError('Could not load the departments. Please try again.')
  return ((data ?? []) as (Department & { archived_at: string | null })[]).map(({ archived_at, ...d }) => ({
    ...d,
    // A retired department keeps its past figures in church-wide reports, marked as retired.
    name: archived_at ? `${d.name} (retired)` : d.name,
  }))
}
